import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { SectorDto, CreateSectorDto, UpdateSectorDto } from "./sectors.dto";
import { FilteredListDto } from "../base/base.dto";
import { StandardDto } from "../standards/standards.dto";

const services = {
  GetAll(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<FilteredListDto<SectorDto>>("sectors", config);
  },
  Add(dto: CreateSectorDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<SectorDto>("sectors", dto, config);
  },
  Delete(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.remove<SectorDto>(`sectors/${id}`, config);
  },
  Get(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<SectorDto>(`sectors/${id}`, config);
  },
  Update(dto: UpdateSectorDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<SectorDto>("sectors", dto, config);
  },
  GetStandards(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<StandardDto[]>(`sectors/${id}/standards`, config);
  },
};
export default services;
